import { toast } from "sonner";

const KEY = "mw_voice";
export const voiceOn = () => localStorage.getItem(KEY) !== "0";
export const setVoiceOn = (v) => localStorage.setItem(KEY, v ? "1" : "0");

const FEMALE = /(yelda|filiz|emel|seda|zeynep|female|kadın|google türkçe|google turkish)/i;
const pickVoice = () => {
  const vs = window.speechSynthesis?.getVoices() || [];
  const tr = vs.filter((v) => (v.lang || "").toLowerCase().startsWith("tr"));
  return tr.find((v) => FEMALE.test(v.name)) || tr[0] || null;
};
if (typeof window !== "undefined" && window.speechSynthesis) window.speechSynthesis.onvoiceschanged = () => pickVoice();

export const speak = (text) => {
  if (!voiceOn() || !window.speechSynthesis) return;
  const u = new SpeechSynthesisUtterance(String(text).toLocaleLowerCase("tr-TR"));
  u.lang = "tr-TR"; u.rate = 1.05; u.pitch = 1.15;
  const v = pickVoice(); if (v) u.voice = v;
  window.speechSynthesis.cancel(); window.speechSynthesis.speak(u);
};

export const warn = (text, kind = "warning") => { (kind === "error" ? toast.error : toast.warning)(text); speak(text); };
